.select {
  min-width: 14rem;
  padding: 0.375rem 0.5rem;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background-color: var(--surface-raised);
  color: var(--text);
  font: inherit;
}

.select:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
